import api from "~/api/api";
import {Taxonomy as TaxonomyEntity} from "~/dto/Taxonomy";

export class Taxonomy {

    static async getTree(): Promise<Array<TaxonomyEntity>> {
        const tree = await api("/taxonomies/tree", { only_visible: 1 });

        return tree.map((el: Object) => TaxonomyEntity.createFromObj(el));
    }

    static async getInfo(id: number): Promise<TaxonomyEntity> {
        const taxonomy = await api("/taxonomies/info", {id});
        return TaxonomyEntity.createFromObj(taxonomy);
    }

}